// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d4f12467","787":"a32c20b4"}[chunkId] + ".chunk.js";
};